import { render, staticRenderFns } from "./LayoutInsertDetails.vue?vue&type=template&id=d4d282b6&scoped=true&"
import script from "./LayoutInsertDetails.vue?vue&type=script&lang=ts&"
export * from "./LayoutInsertDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutInsertDetails.vue?vue&type=style&index=0&id=d4d282b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d282b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VDivider,VRow,VSelect,VTextField,VTextarea})
